<template>
  <div>
    <vs-popup
      fullscreen
      :title="$t('GenericItems') + ': ' + genericProductItemsmodel.name"
      :active.sync="showModal"
    >
      <form>
        <div class="vx-row mb-2">
          <div class="vx-col lg:w-3/12">
            <label class="vs-select--label">{{ $t("GenericProduct") }}</label>
            <treeselect
              name="genericProduct"
              :multiple="false"
              :placeholder="$t('SearchGenericProduct')"
              :async="true"
              :load-options="loadOptions"
              v-validate="'required'"
              class="search-input"
              ref="genericProduct"
              @select="onGenericProductSelected"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('genericProduct')"
              >{{ errors.first("genericProduct") }}</span
            >
          </div>

          <div class="vx-col lg:w-1/12">
            <label class="vs-select--label">{{ $t("Count") }}</label>
            <input
              type="number"
              v-model="itemModel.attributeInfoCommand.count"
              label="تعداد"
              style="
                width: 100%;
                height: 2em;
                border-radius: 4px;
                border: 1px solid rgba(0, 0, 0, 0.1);
                font-size: 20px;
                text-align: center;
              "
            />
          </div>
          <div style="padding-top: 20px" class="vx-col">
            <ul style="margin: 0 0 15px 25px" class="alignment-menu">
              <li
                @click="onMaxCount(1)"
                style="border-left: 1px solid rgb(202, 202, 202)"
              >
                <input
                  id="maxCountInput"
                  type="radio"
                  v-model="itemModel.attributeInfoCommand.selectOption"
                  @change="onMaxCount($event)"
                  value="1"
                />
                <label class="label">تک انتخابی</label>
              </li>
              <li @click="onMaxCount(2)">
                <input
                  id="maxCountInput"
                  type="radio"
                  v-model="itemModel.attributeInfoCommand.selectOption"
                  @change="onMaxCount($event)"
                  value="2"
                />
                <label class="label">چند انتخابی</label>
              </li>
            </ul>
            <ul class="alignment-menu1">
              <li
                @click="onRequiring(true)"
                style="border-left: 1px solid rgb(202, 202, 202)"
              >
                <input
                  id="requiringInput"
                  type="radio"
                  v-model="itemModel.attributeInfoCommand.isRequired"
                  @change="onRequiring($event)"
                  value="true"
                />
                <label class="label1">اجباری</label>
              </li>
              <li @click="onRequiring(false)">
                <input
                  id="requiringInput"
                  type="radio"
                  v-model="itemModel.attributeInfoCommand.isRequired"
                  @change="onRequiring($event)"
                  value="false"
                />
                <label class="label1">غیر اجباری</label>
              </li>
            </ul>
          </div>
          <div class="vx-col lg:w-1/12 pt-6">
            <vs-button
              type="filled"
              size="medium"
              icon-pack="feather"
              icon="icon-plus"
              class="d-inline"
              @click.prevent="addItemInfo()"
            ></vs-button>
          </div>
        </div>
      </form>
      <data-grid
        ref="grid"
        stripe
        :data-source="gridDataSource"
        :search-data="gridSearchData"
        :columns="[
          { title: $t('Name') },
          { title: 'وضعیت اجباری بودن' },
          { title: 'حداکثر تعداد قابل استفاده' },
          { title: 'حداکثر تعداد' },
          { title: $t('Action') },
        ]"
      >
        <template slot-scope="{ row }">
          <td style="width: 32%">
            <span>{{ row.name }}</span>
          </td>
          <td style="width: 17%">
            {{
              row.genericProductItemInfoDto.isRequired ? "اجباری" : "غیر اجباری"
            }}
          </td>
          <td style="width: 17%">
            {{
              row.genericProductItemInfoDto.selectOption == 2
                ? "چند انتخابی"
                : "تک انتخابی"
            }}
          </td>
          <td style="width: 17%">
            {{ row.genericProductItemInfoDto.count }}
          </td>
          <td style="width: 17%">
            <vs-button
              radius
              color="danger"
              size="small"
              type="gradient"
              icon-pack="feather"
              icon="icon-x"
              @click.prevent="removeItemInfo(row.id)"
              class="d-inline"
            ></vs-button>
          </td>
        </template>
      </data-grid>
    </vs-popup>
  </div>
</template>
<style lang="scss">
.add-btn {
  margin-top: 1.5rem;
}
.radio_btn {
  margin: 13px 15px 5px;
}
.radio_btn div {
  margin: 0 25px;
}
.radio_btn input {
  margin: 0 5px;
}
.alignment-menu {
  display: inline-flex;
  padding: 0 1em;
  border-radius: 4px;
  margin: 0;
  padding: 0;
  list-style: none;
  border: 1px solid rgb(202, 202, 202);
  background-color: rgb(230, 230, 230);
  height: 3em;
}
.alignment-menu1 {
  display: inline-flex;
  padding: 0 1em;
  border-radius: 4px;
  margin: 0;
  padding: 0;
  list-style: none;
  border: 1px solid rgb(202, 202, 202);
  background-color: rgb(230, 230, 230);
  height: 3em;
}
.label {
  display: inline-block;
  color: black;
  border-radius: 4px;
  transition: all 0.1s ease;
  width: 10em;
  text-align: center;
  align-content: center;
  padding-top: 10px;
  height: 100%;

  &:hover,
  &:focus {
    background-color: #9fd4b1;
  }

  &:active {
    background-color: #ceeed8;
    transition: border-color 0.1s ease, background-color 0s;
    border: none;
  }
}
.label1 {
  display: inline-block;
  color: black;
  border-radius: 4px;
  transition: all 0.1s ease;
  width: 10em;
  text-align: center;
  align-content: center;
  padding-top: 10px;
  height: 100%;

  &:hover,
  &:focus {
    background-color: #9fd4b1;
  }

  &:active {
    background-color: #ceeed8;
    transition: border-color 0.1s ease, background-color 0s;
    border: none;
  }
}
#maxCountInput {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  overflow: hidden;
  padding: 0;
  position: absolute !important;
  white-space: nowrap;
  width: 1px;

  &:checked + .label {
    background-color: #007470;
    color: white;
  }
}
#requiringInput {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  overflow: hidden;
  padding: 0;
  position: absolute !important;
  white-space: nowrap;
  width: 1px;

  &:checked + .label1 {
    background-color: #007470;
    color: white;
  }
}
</style>

<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
import DataGrid from "@/components/datagrid/DataGrid";
import Treeselect from "@/components/CustomTreeSelect.vue";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
const dict = {
  custom: {
    genericProduct: {
      required: "لطفا دسته محصول را انتخاب نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  props: {
    showGenericItemsPopup: { default: false },
    genericProductItemsmodel: {
      default: {},
    },
  },

  data() {
    return {
      onAddItem: false,
      currentValue: 0,
      itemModel: {
        parentGenericProductId: null,
        genericProductId: null,
        attributeInfoCommand: {
          count: Number,
          isRequired: Boolean,
          selectOption: Number,
        },
      },
      gridDataSource: { data: [] },
      gridSearchData: {},
      searchQueryNew: "",
      searchQueryOld: "",
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.showGenericItemsPopup;
      },
      set: function () {
        this.$emit("finish");
      },
    },
  },
  methods: {
    onMaxCount(tempSelectOption) {
      this.itemModel.attributeInfoCommand.selectOption = tempSelectOption;
    },
    onRequiring(tempIsRequired) {
      this.itemModel.attributeInfoCommand.isRequired = tempIsRequired;
    },
    ...mapActions({
      assignItemInfo: "genericProduct/assignItemInfo",
      fetchGenericProductsSearch: "genericProduct/fetchSearch",
      unassignItemInfo: "genericProduct/unassignItemInfo",
    }),
    loadOptions({ action, searchQuery, callback }) {
      this.searchQueryNew = searchQuery;
      this.searchQueryOld = this.searchQueryNew;
      setTimeout(() => {
        this.searchQueryNew = searchQuery;
        if (this.searchQueryOld == this.searchQueryNew) {
          if (action === ASYNC_SEARCH) {
            this.fetchGenericProductsSearch(searchQuery).then((r) => {
              const options = [];
              r.forEach(function (element) {
                options.push({
                  id: element.id,
                  label: element.name,
                });
              });
              callback(null, options);
            });
          }
        }
      }, 2000);
    },
    onGenericProductSelected(data) {
      this.itemModel.genericProductId = data.id;
    },
    addItemInfo() {
      if (this.itemModel.genericProductId) {
        if (this.itemModel.attributeInfoCommand.count > 0) {
          if (
            this.itemModel.attributeInfoCommand.selectOption == 2 ||
            this.itemModel.attributeInfoCommand.selectOption == 1
          ) {
            if (
              this.itemModel.attributeInfoCommand.isRequired == true ||
              this.itemModel.attributeInfoCommand.isRequired == false
            ) {
              this.assignItemInfo(this.itemModel).then(() => {
                this.$vs.notify({
                  title: "عملیات موفق",
                  text: "رکورد مورد نظر با موفقیت اضافه شد!",
                  color: "success",
                });
                this.$refs.grid.renderGrid();
              });
              this.$refs.genericProduct.clear();
              this.$validator.reset();
            } else alert("قسمت استفاده از این کالا در این دسته را وارد کنید");
          } else
            alert("قسمت حداکثر تعداد قابل استفاده در این دسته را وارد کنید");
        } else alert("تعداد را وارد کنید");
      } else alert("کالا را وارد کنید");
    },
    removeItemInfo(genericProductId) {
      var parentGenericProductId = this.genericProductItemsmodel.id;
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.unassignItemInfo({
            parentGenericProductId,
            genericProductId,
          }).then(() => {
            this.$swal({
              position: "center-center",
              type: "success",
              text: "رکورد مورد‌نظر با موفقیت حذف شد!",
              showConfirmButton: false,
              timer: 2000,
            });
            this.$refs.grid.renderGrid();
          });
        }
      });
    },
  },
  watch: {
    showGenericItemsPopup() {
      if (this.showGenericItemsPopup == true) {
        this.itemModel.parentGenericProductId =
          this.genericProductItemsmodel.id;
        this.itemModel.attributeInfoCommand.count =
          this.genericProductItemsmodel.count;

        this.$validator.reset();

        this.gridDataSource = {
          type: "app",
          service:
            "/ProductManagement/api/GenericProductsQuery/" +
            this.genericProductItemsmodel.id +
            "/generic-product-items-with-paging",
        };

        setTimeout(() => {
          this.$refs.grid.renderGrid();
        }, 0);
      } else {
        this.gridDataSource = { data: [] };
        this.$refs.genericProduct.clear();
        setTimeout(() => {
          this.$refs.grid.renderGrid();
        }, 0);
      }
    },
  },
  components: {
    Treeselect,
    DataGrid,
  },
};
</script>
